import { Component, Vue } from 'vue-property-decorator';
import { Report } from '@/models/Report';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { debounce } from 'lodash';

@Component<ImportReportDialog>({})
export default class ImportReportDialog extends Vue {
  protected importableReports: Report[] = [];

  protected selectedReport = '';

  protected isLoading = false;

  protected isImporting = false;

  // eslint-disable-next-line @typescript-eslint/ban-types
  protected debouncedSearchReports: Function = debounce(this.fetchImportableReports, 300);

  protected reportSearch = '';

  protected async fetchImportableReports(): Promise<void> {
    this.importableReports = [];
    if (! this.reportSearch) {
      return;
    }

    this.isLoading = true;

    await new Report().importableReportsEndpoint()
      .filter({
        statuses: ['downloaded', 'zienswijze_closed', 'objection_closed'],
        case_number: this.reportSearch,
      })
      .all()
      .then((reports: Report[]) => {
        this.importableReports = reports;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });

    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('close');
  }

  protected importReport(): void {
    this.isImporting = true;
    if (! this.selectedReport) {
      this.isImporting = false;
      return;
    }

    new Report().importReport(this.selectedReport);
  }
}
